import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MODAL_DATA, ModalReference } from '@domgen/dgx-fe-components/modal';
import { ShufflerService } from '../../../manage-my-repair/components/engineer-tracking/feedback-survey/shuffler-service.service';
import { DgxComponentsIconModule } from '@domgen/dgx-fe-components/icon';
import { DgxComponentsButtonModule } from '@domgen/dgx-fe-components/button';
import { FormsModule } from '@angular/forms';
import { createFocusTrap } from 'focus-trap';

@Component({
  standalone: true,
  selector: 'claims-claim-cancellation-reasons',
  imports: [
    CommonModule,
    DgxComponentsIconModule,
    DgxComponentsButtonModule,
    FormsModule,
  ],
  templateUrl: './claim-cancellation-reasons.component.html',
  styleUrls: ['./claim-cancellation-reasons.component.scss'],
})
export class ClaimCancellationReasonsComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  cancellationReasons: string[] = [];
  cancellationReasonSelected: string = '';
  otherReason: string;
  showError = false;
  private focusTrap: any;

  @ViewChild('modalElement') modalElement!: ElementRef;

  constructor(
    @Inject(MODAL_DATA)
    public data: {
      title: string;
      reasons: string[];
      buttons: any;
      body: string;
      subTitle: string;
      errorMessage: string;
      errorMessageOther: string;
      hasAmendableBooking: boolean;
    },
    private modalRef: ModalReference<
      ClaimCancellationReasonsComponent,
      { action: string; reason?: string }
    >,
    private shufflerService: ShufflerService
  ) {}

  closeModal() {
    this.deactivateFocus();
    this.modalRef.close();
  }

  ngOnDestroy(): void {
    this.deactivateFocus();
  }

  ngAfterViewInit() {
    if (!this.focusTrap) {
      this.focusTrap = createFocusTrap(this.modalElement.nativeElement);
      this.focusTrap.activate();
    }
    document.body.classList.add('no-scroll');
  }

  ngOnInit(): void {
    this.cancellationReasons = this.shufflerService.shuffleArrayBasedOnId(
      this.data.reasons
    );
  }

  selectReason(reason: string): void {
    this.cancellationReasonSelected = reason;
  }

  onKeyDown(event: KeyboardEvent, reason: string): void {
    if (event.key === 'Enter' || event.key === '') {
      event.preventDefault();
      this.selectReason(reason);
    }
  }

  onButtonClick(action: string) {
    if (action === 'close') {
      this.modalRef.close({ action: 'keep' });
    } else if (action === 'submit') {
      if (
        !this.cancellationReasonSelected ||
        (this.cancellationReasonSelected === 'Other' &&
          !this.otherReason?.trim())
      ) {
        this.showError = true;
        return;
      }
      this.showError = false;

      const reasonForCancelling =
        this.cancellationReasonSelected === 'Other'
          ? this.otherReason.trim()
          : this.cancellationReasonSelected;

      this.modalRef.close({ action: 'cancel', reason: reasonForCancelling });
    }
  }

  // had to use this lib to create a focused state on this modal and prevent scrolling & tabbing elsewhere
  private deactivateFocus(): void {
    if (this.focusTrap) {
      this.focusTrap.deactivate();
    }

    document.body.classList.remove('no-scroll');
  }
}
